import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect as OriginalRedirect } from 'react-router-dom';
import { isLabPartner } from '../../helpers';

const Redirect = ({ management, organization, thirdParty, ...props }) => {
  const isManagement = useSelector(state => state.auth.isManagement);
  const currentUser = useSelector(state => state.auth.user);

  const override = { to: organization };
  if (isManagement) {
    override.to = management;
  }

  if (currentUser && isLabPartner(currentUser) && isManagement) {
    override.to = thirdParty;
  }

  return <OriginalRedirect {...{ ...props, ...override }} />;
};

Redirect.propTypes = {
  management: PropTypes.string.isRequired,
  organization: PropTypes.string.isRequired,
  thirdParty: PropTypes.string.isRequired
};

export default Redirect;
